import { render, staticRenderFns } from "./B_ExpandExample.vue?vue&type=template&id=31f885d0&"
import script from "./B_ExpandExample.vue?vue&type=script&lang=ts&"
export * from "./B_ExpandExample.vue?vue&type=script&lang=ts&"
import style0 from "./B_ExpandExample.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.9.2_1ebeed51c9db1c19ddd7ada5173f91fd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports